import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import {
    REPORTING_TRANSACTIONS_FAILURE,
    REPORTING_TRANSACTIONS_LOAD,
    REPORTING_TRANSACTIONS_SUCCESS
} from './reportingActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = { transactions: [] }, action = {}) {
    let newState;

    switch (action.type) {
        case REPORTING_TRANSACTIONS_LOAD:
            newState = {
                ...state,
                loading: true,
                transactions: []
            };

            return isEqual(state, newState) ? state : newState;

        case REPORTING_TRANSACTIONS_SUCCESS:
            newState = {
                ...state,
                loading: false,
                transactions: action.transactions
            };

            return isEqual(state, newState) ? state : newState;

        case REPORTING_TRANSACTIONS_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false,
                transactions: []
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getReportingEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'reporting')
);

export const getTransactionsReport = createSelector(
    getReportingEntity,
    (entity) => get(entity, 'transactions')
);

export const getTransactionsReportError = createSelector(
    getReportingEntity,
    (entity) => get(entity, 'error')
);

export const getTransactionsReportErrorMessage = createSelector(
    getTransactionsReportError,
    (error) => get(error, 'message')
);

export const getIsTransactionsReportLoading = createSelector(
    getReportingEntity,
    (entity) => get(entity, 'loading')
);
